import { createContext, useState, useEffect } from 'react';
import { getPassTypes } from '../services/PassService';

// Create the context
export const PassContext = createContext();

export const PassProvider = ({ children }) => {
    const [types, setTypes] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchTypes = async () => {
            try {
                const data = await getPassTypes();
                setTypes(data.data);
            } catch (error) {
                setError('Error fetching pass types.');
            }
        };
        fetchTypes();
    }, []);
    
    return (
        <PassContext.Provider value={{ types, error }}>
            {children}
        </PassContext.Provider>
    );
};